module.exports = __webpack_public_path__ + "img/1_C.d598d62e.png";